import { getAwaitSpinAction } from 'automaton/actions/AwaitSpinAction'
import { getAutoState } from 'automaton/states/AutoSpinState'
import { getGambleState } from 'automaton/states/GambleState'
import { getSpinState } from 'automaton/states/SpinState'
import { signal } from 'services/SignalsService'

export function getBetState() {
  const name = 'BET'
  const freeBetModel = game.models.FreebetsModel.get()

  if (game.models.GameModel.requestAgainAllowed) {
    game.models.WinModel.set({})
    game.models.GambleModel.setIsGamble(false)
    game.models.GambleModel.setRest(null)

    signal.dispatch('BUTTON:GambleClose')

    game.models.GameModel.requestAgainAllowed = false
  }
  else {
    const { rest } = game.models.GambleModel.get()
    const isGamble = game.models.GambleModel.getIsGamble()
    if (
      isGamble &&
      !game.models.AutoLimitModel.isAuto &&
      rest !== undefined &&
      rest !== 0
    ) {
      if (freeBetModel.isFreeBet) {
        if (freeBetModel.lastSpinWin > 0) {
          signal.dispatch('GAMBLE-FEATURE:SHOW-BUTTON')
        }
      }
      else {
        signal.dispatch('GAMBLE-FEATURE:SHOW-BUTTON')
      }
    }
  }

  if (!freeBetModel.rest && freeBetModel.total > 0) {
    signal.dispatch('FREEBET:END', freeBetModel.status === 'expired')

    signal.promise('RADIO:FB').then(() => {
      const { BetModel } = game.models
      const availableBets = BetModel.getList()
      const newBet = availableBets.indexOf(freeBetModel.regularBetToRestore) > 0 ? freeBetModel.regularBetToRestore : availableBets[0]

      BetModel.setValue(newBet)
    })
  }
  signal.dispatch('FREEBET:Enabled', false)

  const actions = [getAwaitSpinAction()]
  const transition = (isAuto) =>
    isAuto
      ? getAutoState()
      : game.models.GambleModel.getStartGamble()
        ? getGambleState()
        : getSpinState()

  return {
    name,
    actions,
    transition,
  }
}
